import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AgentModel} from "../../../../agents/angular/models/agent.model";

require('./dashboard-agents-table.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-agents-table',
  templateUrl: './dashboard-agents-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardAgentsTableComponent implements OnChanges {

  @Input() agents: AgentModel[];
  @Output() fetchNextEvent = new EventEmitter<null>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agents) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }


}
